import http from './httpList.js'
// 随机id当做设备标识
function randomRangeId (num = 8) {
  var returnStr = ''
  var charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < num; i++) {
    var index = Math.round(Math.random() * (charStr.length - 1))
    returnStr += charStr.substring(index, index + 1)
  }
  localStorage.setItem('bcm_device_no', returnStr)
  return returnStr
}
if (!localStorage.getItem('bcm_device_no')) {
  randomRangeId()
}
function signature () {
  return {
    phoneSignature: async function () {
      const deviceNo = localStorage.getItem('bcm_device_no')
      const p = new Promise((resolve, reject) => {
        http.getHttp({
          name: 'phoneSignature',
          params: {
            headers: {
              deviceNo: deviceNo
            }
          }
        },
        (res) => {
          resolve(res.data)
        })
      })
      const result = await p
      return result
    },
    commonSignature: async function () {
      const deviceNo = localStorage.getItem('bcm_device_no')
      const p = new Promise((resolve, reject) => {
        http.getHttp({
          name: 'commonSignature',
          params: {
            headers: {
              deviceNo: deviceNo
            }
          }
        },
        (res) => {
          resolve(res.data)
        })
      })
      const result = await p
      return result
    }
  }
}
export default {
  signature
}



// WEBPACK FOOTER //
// ./src/api/signature.js